import { AlertTriangle, Phone } from "lucide-react";

const SuspensionBanner = ({ message }) => {
  return (
    <div 
      data-testid="suspension-banner"
      className="bg-red-500 text-white px-4 py-3 flex items-center gap-3 shadow-lg"
    >
      <AlertTriangle className="w-5 h-5 flex-shrink-0" />
      <div className="flex-1">
        <p className="text-sm font-medium">
          {message || "Your account has been suspended. You cannot place orders."}
        </p>
        <p className="text-xs opacity-90 mt-0.5 flex items-center gap-1">
          <Phone className="w-3 h-3" />
          Contact Fleety support for assistance
        </p>
      </div>
    </div>
  );
};

export default SuspensionBanner;
